import { downloadFileChunk } from "../services/fileChunkService";

function mergeChunksIntoBlob(
  chunks: any,
  mimeType = "application/octet-stream" // Default MIME type for PDF files
) {
  return new Blob(chunks, { type: mimeType });
}

//this function downloads a file in chunks and merges them into a single Blob object
// it returns a URL that can be used to access the merged file

export const downloadFile = async (
  blobFilName: string,
  requestFrom: number = 1
) => {
  let index = 0;
  let fileSize = 0;
  const fileChunks = [];
  let fileName = ""; // Default file name if not found in headers
  let fileExtension = "";
  do {
    try {
      const response = await downloadFileChunk(blobFilName, index, requestFrom);
      if (response.status === 200) {
        const contentDisposition = response.headers["content-disposition"];
        if (contentDisposition) {
          fileName =
            response.headers["content-disposition"]?.match(
              /filename="([^"]+)"/
            )?.[1];
          fileExtension = fileName?.split(".").pop() || "";

          const totalFileSize = contentDisposition.match(
            /total-file-size="([^"]+)"/
          )?.[1];
          const totalFileSizeNum = parseInt(totalFileSize, 10);
          const end = contentDisposition.match(/end="([^"]+)"/)?.[1];
          const endNum = parseInt(end, 10);
          if (fileName && totalFileSizeNum && endNum) {
            const chunk = response.data; // Assuming response.data is the file chunk
            fileChunks.push(chunk);
            index = endNum + 1 || 0;
            fileSize = totalFileSizeNum - 1 || 0;
          } else {
            throw new Error(
              "File name or size not found in content-disposition header."
            );
          }
        } else {
          throw new Error(
            "File name or size not found in content-disposition header."
          );
        }
      }
    } catch (error) {
      console.error("Error in downloading file chunk:", error);
      throw new Error("Failed to download file chunk");
    }
  } while (index < fileSize);
  if (fileChunks.length === 0) {
    throw new Error("No file chunks downloaded.");
  }
  const mergedBlob = mergeChunksIntoBlob(fileChunks);
  const url = window.URL.createObjectURL(mergedBlob);
  return { url, fileName, fileExtension }; // Return the URL and file name
};
